<!-- 注册 -->
<template>
    <div class="register">
        <div class="navbar themeBg"></div>
        <div class="main">
            <div class="cont">
                <div class="contWrap flex">
                    <div class="contTitle">注册</div>
                </div>
                <div class="item">
                    <van-field v-model="phone" type="tel" @update:model-value="phoneChange" placeholder="请输入您的手机号" clearable>
                        <template #label>
                            <img class="labelIcon" src="@/assets/register/phoneIcon.png" alt="">
                        </template>
                    </van-field>
                </div>
                <div class="codeWrap item marginBtm15">
                    <div class="">
                        <van-field v-model="authCode" label="验证码" maxlength="6" type="number" placeholder="请输入验证码" clearable>
                            <template #label>
                                <img class="labelIcon" src="@/assets/register/codeIcon.png" alt="">
                            </template>
                        </van-field>
                    </div>
                    <div class="codeWrapRight" @click="getCode">
                        {{num == 60 ? '获取验证码' : `${num}后获取`}}
                    </div>
                </div>
                <div class="item marginBtm15">
                    <van-field v-model="password" label="密码" :type="showPassword ? 'text' : 'password'" placeholder="6-16位由字母、数字组合的登录密码" clearable>
                        <template #right-icon>
                            <van-icon v-if="showPassword" name="eye-o" @click="setShowPassword"/>
                            <van-icon v-else name="closed-eye" @click="setShowPassword"/>
                        </template>
                        <template #label>
                            <img class="labelIcon" src="@/assets/register/passwordIcon.png" alt="">
                        </template>
                    </van-field>
                </div>
                <div class="item">
                    <van-field label="省市区" type="tel" v-model="provinceDesc" readonly @click="show=true"  placeholder="请选择省市区" isLink clearable>
                        <template #label>
                            <img class="labelIcon" src="@/assets/register/passwordIcon.png" alt="">
                        </template>
                    </van-field>
                </div>
                <div class="item marginBtm15">
                    <van-field v-model="parentUserPhoneValue" disabled label="邀请人" placeholder="请输入邀请人手机号" clearable>
                        <template #label>
                            <img class="labelIcon" src="@/assets/register/parentIcon.png" alt="">
                        </template>
                    </van-field>
                </div>
                <div class="submit">
                    <van-button :disabled="userExist" color="#F08805" round block @click="registe">确定</van-button>
                </div>
            </div>
        </div>
                <div @click="goDownload" class="goDownload">跳转下载APP</div>
            <div class="pull">
                <div class="pullLeft">
                    我已阅读并同意<span class="themeColor" @click.stop="goProtocolRge">《用户协议》</span>
                </div>
            </div>

        <!-- 选择省市区 -->
        <van-popup v-model:show="show" position="bottom">
            <van-area title="标题" :area-list="areaList" @confirm="cityConfirm" />
        </van-popup>

        <!-- 图形验证码 -->
        <Verify
        ref="verify"
        :captchaType="captchaType"
        :account="phone"
        :mode="mode"
        :img-size="{width:'300px',height:'140px'}"
        @success="handleSuccess"
        ></Verify>

        <div class="wechatBox" v-if="isWechat">
            <img src="@/assets/download/dynamicImg.gif" alt="">
            <div>
                <p>请点击左上角“…”在浏览器打开此页面。</p>
                <p>(备注：苹果手机用户请在Safari中打开此页面）</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive , getCurrentInstance, toRefs, onUnmounted } from 'vue';
import { Field , Icon , Button , Checkbox , NavBar , Area , Popup } from 'vant';
import storage from 'store';
import { ACCESS_TOKEN , BRANDID , userAgent } from '@/utils/types';
import { getUserAgent } from '@/utils/index';
import { validPsw } from '@/utils';
import areaLists from '@/assets/area.json';
import Verify from '@/components/verifition/Verify'
import { getCaptcha } from '@/api/brand';
export default {
    components:{
        [Field.name]:Field,
        [Icon.name]:Icon,
        [Button.name]:Button,
        [Checkbox.name]:Checkbox,
        [NavBar.name]:NavBar,
        [Area.name]:Area,
        [Popup.name]:Popup,
        Verify,
    },
    setup() {
        storage.clearAll();
        const { proxy } = getCurrentInstance();
        const phone = ref('');  // 手机号
        const authCode = ref(''); // 验证码
        const password = ref(''); // 登录密码
        const showPassword = ref(false)
        const repPassword = ref(''); // 确认登录密码
        const showRepPassword = ref(false)
        const payPassword = ref('')
        const showPayPassword = ref(false)
        const parentUserPhone = ref(proxy.getHashParam('phone')) // 推荐人手机号
        const parentUserPhoneValue = ref('');
        const province = ref('');
        const city = ref('');
        const area = ref('');
        const provinceDesc = ref('');
        if(parentUserPhone.value != ''){
            parentUserPhoneValue.value = proxy.hidePhone(parentUserPhone.value)
        }
        const brandId = proxy.getHashParam('brandId')
        const checked = ref(true); // 协议勾选状态
        const userExist = ref(false); // 用户是否注册
        const getCodeLoading = ref(false);
        const num = ref(60)
        const timer = ref(null)
        const verify = ref(null)
        const captchaType = ref('')
        const mode = ref('pop');
        const captchaId = proxy.captchaId;

        const downAddress = reactive({
            android: undefined,
            ios: undefined,
            userAgent: undefined,
        })
        const isWechat = ref(false)
        // 获取当前用户终端类型
        downAddress.userAgent = getUserAgent()
        if(downAddress.userAgent == userAgent.WECHAT){
            isWechat.value = true
            return {
                userAgent,
                downAddress,
                goDownload,
                isWechat,
            }
        }

        // 获取系统的token
        function getToken(){
            proxy.$http.brandApi.getToken(brandId)
            .then(res=>{
                if(res.success){
                    storage.set(ACCESS_TOKEN,res[ACCESS_TOKEN], res.expires_in)
                }
            })
        }
        getToken()
        // 获取验证码
        function getCode () {
            console.log(phone.value)
            if(getCodeLoading.value == true){
                return;
            }
            if(phone.value == ''){
                proxy.$toast({position: 'bottom',message:'请输入手机号'})
                return
            }
            if(phone.value.length != 11){
                proxy.$toast({position: 'bottom',message:'请输入正确的手机号'})
                return
            }
            let typeIndex = Math.floor(Math.random() * 2);
            // var typeList = ['blockPuzzle','clickWord'];
            // var typeList = ['clickWord'];
            // captchaType.value = typeList[typeIndex];

            // captchaType.value = 'blockPuzzle';
            // proxy.$refs.verify.show();

            start();
        }
        const handleSuccess = (res)=>{
            console.log(res);
            getCodeApi();
        }
        // 验证接口
        function getCodeApi (){
            getCodeLoading.value = true
            num.value--;
            timer.value = setInterval(()=>{
                num.value--;
                console.log(num.value,'num')
                if(num.value == 0){
                    getCodeLoading.value = false
                    clearInterval(timer.value)
                    num.value = 60;
                }
            },1000)
            proxy.$http.loginApi.getCode(phone.value)
            .then(res=>{
                console.log(res,'res')
                if(res.success){
                    proxy.$toast({position: 'bottom',message:'验证码获取成功'})
                }else{
                    proxy.$toast({position: 'bottom',message:res.errMessage})
                }
            })
        }
        // 注册
        function registe () {
            if(phone.value == ''){
                proxy.$toast({position: 'bottom',message:'请输入手机号'})
                return
            }
            if(phone.value.length != 11){
                proxy.$toast({position: 'bottom',message:'请输入正确的手机号'})
                return
            }
            if(authCode.value == ''){
                proxy.$toast({position: 'bottom',message:'请输入验证码'})
                return
            }
            if(password.value == ''){
                proxy.$toast({position: 'bottom',message:'请输入登录密码'})
                return
            }
            // if(password.value.length < 6 || password.value.length > 16 || !validPsw(password.value)){
            //     proxy.$toast({position: 'bottom',message:'登录密码由6-16位由字母、数字组合！'})
            //     return
            // }
            if(password.value.length < 6 || password.value.length > 16){
                proxy.$toast({position: 'bottom',message:'登录密码由6-16位由字母、数字组合！'})
                return
            }
            if(payPassword.value == '123456'){
                proxy.$toast({position: 'bottom',message: '支付密码不能太过简单'})
                return;
            }
            if(province.value == ''){
                proxy.$toast({position: 'bottom',message: '请选择省市区'})
                return;
            }
            proxy.$http.loginApi.register(phone.value,authCode.value,password.value,parentUserPhone.value)
            .then(res=>{
                if(res.success){
                    storage.set(ACCESS_TOKEN,res[ACCESS_TOKEN], res.expires_in);
                    updateUser();
                    // proxy.$toast({position: 'bottom',message:'注册成功，正在跳转下载页面！'})
                    // userExist.value = true
                    // setTimeout(()=>{
                    //     goDownload()
                    // },1000)
                }else{
                    proxy.$toast({position: 'bottom',message:res.errMessage})
                }
            })
        }

        // 修改用户信息
        function updateUser (){
            proxy.$http.userApi.updateUser({province: province.value,city: city.value,country: area.value})
            .then(res=>{
                if(res.success){
                    goNext();
                }else{
                    proxy.$toast({position: 'bottom',message:res.errMessage})
                }
            })
        }

        // 跳转
        const goNext = () => {
            proxy.$toast({position: 'bottom',message:'注册成功，正在跳转下载页面！'})
                    userExist.value = true
                    setTimeout(()=>{
                        goDownload()
                    },1000)
        }

        function setShowPassword(){
            console.log(showPassword)
            showPassword.value = !showPassword.value
        }
        function setRepShowPassword(){
            showRepPassword.value = !showRepPassword.value
        }
        function setPayShowPassword(){
            showPayPassword.value = !showPayPassword.value
        }
        // 跳转下载页面
        function goDownload(){
            if(userExist.value){
                storage.set(BRANDID , brandId)
                proxy.$router.push({name: 'download',params:{'brandId':brandId}})
            }else{
                if(phone.value == ''){
                    proxy.$toast({message:'请输入手机号!',position: 'bottom'})
                }else{
                    proxy.$toast({message:'当前手机号还未注册，请先注册!',position: 'bottom'})
                }
            }
        }
        // 判断用户是否注册
        function phoneChange(val){
            console.log(val)
            if(val.length == 11){
                proxy.$http.loginApi.userIsExist(val)
                .then(res=>{
                    if(res.success){
                        userExist.value = true
                        proxy.$toast({message:'当前手机号已注册，请点击下载app，直接前往下载页面!',position: 'bottom'})
                    }else{
                        userExist.value = false
                    }
                })
            }
        }
        // 跳转注册协议
        function goProtocolRge(){
            proxy.$router.push({name: 'agreement'})
        }
        // 销毁的时候注销定时器
        onUnmounted(()=>{
            console.log('销毁定时器')
            if(timer.value){
                clearInterval(timer.value)
            }
        })

        // 查询省市区
        const show = ref(false);
        const areaList = ref(areaLists);
        // console.log(areaLists,'areaLists')
        // 确认选择省市区
        const cityConfirm = (val) => {
            console.log(val,'val')
            if(val.length == 3){
                province.value = val[0].name;
                city.value = val[1].name;
                area.value = val[2].name;
                provinceDesc.value = val[0].name + '/' + val[1].name + '/' + val[2].name;
            }else{
                province.value = '';
                city.value = '';
                area.value = '';
                provinceDesc.value = '';
            }
            show.value = false;
        }

        // 开始验证
        const start = () => {
            try {
                // 生成一个验证码对象
                // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
                //callback：定义的回调函数
                var captcha = new TencentCaptcha(captchaId, callback, {
                    userLanguage: 'zh-cn',
                    showFn: (ret) => {
                        const {
                        duration, // 验证码渲染完成的耗时(ms)
                        sid, // 链路sid
                        } = ret;
                    },
                });
                console.log(captcha,'TencentCaptcha')
                // 调用方法，显示验证码
                captcha.show();
            } catch (error) {
                console.log(error,'error')
                // 加载异常，调用验证码js加载错误处理函数
                loadErrorCallback();
            }
        }

        // 定义验证码js加载错误处理函数
        const loadErrorCallback = () => {
            var appid = captchaId;
            // 生成容灾票据或自行做其它处理
            var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
            callback({
                ret: 1,
                randstr: '@' + Math.random().toString(36).substr(2),
                ticket: ticket,
                errorCode: 1001,
                errorMessage: 'jsload_error'
            });
        }

        // 验证码验证回调
        const callback = (res) => {
            // 第一个参数传入回调结果，结果如下：
            // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
            // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
            // CaptchaAppId       String    验证码应用ID。
            // bizState    Any       自定义透传参数。
            // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
            // verifyDuration     Int   验证码校验接口耗时（ms）。
            // actionDuration     Int   操作校验成功耗时（用户动作+校验完成）(ms)。
            // sid     String   链路sid。
        ﻿
        ﻿
        ﻿
            // res（用户主动关闭验证码）= {ret: 2, ticket: null}
            // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
            // res（请求验证码发生错误，验证码自动返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
            // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
            if (res.ret === 0) {
                proxy.$http.loginApi.checkTYCaptcha({account: phone.value,ticket: res.ticket,randstr: res.randstr})
                .then(res=>{
                    if(res.success){
                        getCodeApi();
                    }else{
                        proxy.$toast({message: res.errMessage ?? '验证失败' ,position: 'bottom'})
                    }
                })
            }else{
                proxy.$toast({message: res.errorMessage ?? '验证失败' ,position: 'bottom'})
            }
        }

        return {
            phone,
            authCode,
            password,
            repPassword,
            parentUserPhone,
            checked,
            getCode,
            registe,
            showPassword,
            setShowPassword,
            showRepPassword,
            setRepShowPassword,
            goDownload,
            phoneChange,
            userExist,
            goProtocolRge,
            getCodeLoading,
            num,
            showPayPassword,
            payPassword,
            setPayShowPassword,
            parentUserPhoneValue,
            show,
            areaList,
            cityConfirm,
            province,
            city,
            area,
            provinceDesc,
            verify,
            handleSuccess,
            captchaType,
            mode,
        }
    }
}

</script>
<style scoped>
.navbar{
    height: 320px;
    text-align: center;
    color: #FFFFFF;
    font-size: 21px;
    font-weight: 500;
    background: url('../../assets/register/registerBg.png') no-repeat;
    background-size: 100%;
}
.main{
    margin: -62px 12px 50px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 19px 10px;
}
.contTitle{
    margin-left: 10px;
    background: url('../../assets/register/titleBg.png') no-repeat;
    background-size: 100%;
    background-position: bottom;
    padding: 3px 2px;
    font-size: 23px;
    font-weight: bold;
    margin-bottom: 20px;
}
.item{
    height: 54px;
}
.item >>> .van-field{
    flex: 1;
    padding-left: 10px;
    max-height: 40px;
    background: none;
}
.item >>> .van-field__label{
    font-size: 16px;
    color: #333333;
    font-weight: 500;
    width: 30px;
}
.labelIcon{
    width: 22px;
    height: 22px;
}
.codeWrap{
    display: flex;
    align-items: center;
}
.codeWrapRight{
    width: 95px;
    margin-left: 13px;
    flex-shrink: 0;
    border-left: 1px solid #E6E6E6;
    text-align: center;
    color: #EC6E0B;
    font-size: 13px;
    /* margin-top: 33px; */
}
.goDownload{
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    margin: 20px 0;
}
.submit{
    margin: 0 13px;
    display: flex;
}
.pull{
    margin-bottom: 30px;
    text-align: center;
    color: #B7B6B6;
    margin-top: 30px;
}

.wechatBox{
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.8);
    color: #FFFFFF;
}
.wechatBox>div{
    text-indent: 30px;
    line-height: 20px;
    font-size: 14px;
}
</style>